import api from '@/utils/api'

export default {
    login(data) {
        return api.post(`admin-users/login`, data)
    },
    refreshToken(data) {
        return api.post(`users/refresh-token`, data)
    },
    createUser(data) {
        return api.post(`users`, data)
    },
    getUser(userId) {
        return api.get(`users/${userId}`)
    },
    getUsers(params) {
        return api.get(`users`, { params })
    },
    updateUser(userId, data) {
        return api.put(`users/${userId}`, data)
    },
    getFilteredUsers(filters, page, size) {
        const params = { ...filters, page, size }
        return api.get(`users`, { params })
    }
}
